export default __webpack_public_path__ + "static/branding-drag-drop-builder-357b77e43e143248a27bd9eb88e0d48f.png";